<section class="ingest-files">
  <app-page-header
    title="Explorador de archivos"
    subtitle="Navega por subcarpetas y revisa el contenido. Si el backend no expone el listado, en vista prevía verás datos de ejemplo."
    icon="File"
  />

  @if (loadingProjects()) {
    <div class="loading-container">
      <lib-empty message="Cargando expedientes" description="Espere por favor..." />
    </div>
  } @else {
    <app-grid-form preset="responsive" wrapperClass="ingest-files__picker-grid">
      <app-grid-form-item [span]="2" class="ingest-field ingest-files__field">
        <app-field-label
          label="Expediente"
          tooltip="Selecciona el expediente para explorar su estructura de carpetas y archivos."
        />
        <lib-select
          label=""
          placeholder="Selecciona un expediente"
          [options]="projectOptions()"
          [(value)]="selectedProjectId"
          [searchable]="true"
        />
      </app-grid-form-item>
      <app-grid-form-item [span]="2" class="ingest-files__picker-action">
        <lib-button
          variant="primary"
          type="button"
          prefixIcon="FolderOpen"
          [disabled]="!selectedProjectId()"
          (clicked)="onProjectPicked(selectedProjectId())"
        >
          Mostrar
        </lib-button>
      </app-grid-form-item>
    </app-grid-form>
  }

  @if (error()) {
    <app-vault-page-alert
      type="error"
      title="Error"
      [message]="error()"
      (closed)="error.set(null)"
    />
  }

  @if (selectedProjectId() && !loadingProject() && project()) {
    <div class="ingest-files__layout">
      <aside class="ingest-files__tree" aria-label="Carpetas">
        <h3 class="ingest-files__sub">Carpetas</h3>
        <app-folder-tree
          [root]="treeRoot()"
          [selectedPath]="selectedPath()"
          (selectPath)="onFolderSelect($event)"
        />
      </aside>
      <div class="ingest-files__main">
        <p class="ingest-files__path">
          <strong>Ruta:</strong>
          {{ selectedPath() || '(raíz)' }}
        </p>
        @if (fileRows().length === 0 && !loadingFiles()) {
          <lib-empty
            icon="File"
            message="Sin archivos en esta carpeta"
            description="Sube documentos desde Cargar o revisa otra carpeta."
          />
        } @else {
          <lib-table
            [config]="filesTableConfig()"
            [data]="fileRows()"
            [loading]="loadingFiles()"
            [pageSize]="tablePageSize()"
            [pageSizeOptions]="tablePageSizeOptions"
            (action)="onFileAction($event)"
          />
        }
      </div>
    </div>
  } @else if (selectedProjectId() && loadingProject()) {
    <div class="loading-container">
      <lib-empty message="Cargando expediente" description="Espere por favor..." />
    </div>
  }
</section>
